import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="m736m4ramc">
        <stop stopColor="#4AB6F5" offset="0%" />
        <stop stopColor="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="eiwc1wa01b">
        <stop stopColor="#7DCFFF" offset="0%" />
        <stop stopColor="#60A2FE" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.471%"
        y1="14.721%"
        x2="90.626%"
        y2="87.999%"
        id="ks5eh2xqnd"
      >
        <stop stopColor="#E2F2FF" offset="0%" />
        <stop stopColor="#E2F2FF" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="5mmun35zja"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#5mmun35zja)" fill="none" fillRule="evenodd">
      <path
        d="M28.68 4.321c6.351 0 12.1 2.59 16.262 6.775a23.132 23.132 0 0 1 6.738 16.361c0 5.526-3.421 12.306-7.652 18.275-5.563 7.85-12.618 14.59-15.348 14.59-2.73 0-9.784-6.74-15.347-14.59-4.23-5.97-7.653-12.75-7.653-18.275 0-6.39 2.575-12.174 6.739-16.361C16.58 6.91 22.329 4.32 28.68 4.32Z"
        stroke="url(#eiwc1wa01b)"
        strokeWidth={2}
        fill="url(#m736m4ramc)"
      />
      <path
        d="M16.636 17.846V9.481c0-.308.249-.558.555-.558h2.218c.306 0 .555.25.555.558v8.365h1.218a1 1 0 0 1 1 1v2.462a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-2.462a1 1 0 0 1 1-1h1.218V1.116C2.218.498 2.715 0 3.328 0h9.981c.294 0 .576.118.784.327.208.209.325.493.325.788v16.731h2.218ZM4.436 4.462v11.153h3.328V4.462H4.436Zm5.546 4.461v6.692H12.2V8.923H9.982Z"
        transform="translate(19.018 16.668)"
        fill="url(#ks5eh2xqnd)"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
